import { useState } from 'react';
import HookFormTextInput from 'components/cef_form/hook-form/HookFormTextInput';
import { PasswordVisibilityIcon } from 'assets/icons';
import styled from 'styled-components';

const PasswordInput = props => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="pos-r">
      <HookFormTextInput {...props} type={isVisible ? 'text' : 'password'} />
      <Toggle
        type="button"
        onClick={() => setIsVisible(!isVisible)}
        className="cef-btn--as-link">
        <PasswordVisibilityIcon
          isVisible={isVisible}
          title={isVisible ? 'Hide password' : 'Show password'}
        />
      </Toggle>
    </div>
  );
};

const Toggle = styled.button`
  position: absolute;
  right: 0;
  top: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 46px;
  height: 46px;
`;

export default PasswordInput;
